import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppIncidentIssueService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppIncidentIssues`);
    }
}
